export enum MenuInterface {
  ADMIN = "admin",
  HOME = "home",
  PORTFOLIO = "portfolio",
  REWARD = "reward",
  EXCHANGE = "exchange",
}

export interface ApiResponseType {
  success: boolean;
  msg: string;
  data?: any;
}

export interface SettingsInterface {
  mintingEnabled: boolean | undefined;
  levelRatios: number[];
  rootSignupAddress: string;
  totalUsdc: number;
  usdcMint: string;
  tokenMint: string;
  tokenRatio: number;
  minSignupAmount: number;
}

export interface TokenInfoInterface {
  mint: string;
  symbol: string;
  decimals: number;
  price: number;
  amount: number;
  name: string;
  imgUri: string;
}

export interface ProfileInterface {
  pubkey: string;
  isAdmin: boolean;
  balances: { [key: string]: TokenInfoInterface };
  totalBalance: number;
  nfts: NftInterface[];
}

export interface NftInterface {
  id: string;
  signupAddress: string;
  referrerMint: string;
  referrerSignupAddress: string;
  investedAmount: number;
}

export enum AmountOption {
  AutoMax = "auto-max",
  Static = "static",
  StaticAuto = "static-auto",
}

export enum IntervalOption {
  Manual = "manual",
  Weekly = "weekly",
  BiWeekly = "bi-weekly",
  Monthly = "monthly",
  TwoMonthly = "two-monthly",
  ThreeMonthly = "three-monthly",
}

export enum RewardStatus {
  None = "none",
  Searching = "searching",
  Running = "running",
  Failed = "failed",
  Done = "done",
  Stopped = "stopped",
}

export enum TxStatus {
  Created = "created",
  Waiting = "waiting",
  Done = "done",
  Failed = "failed",
}

export interface IReward2Settings {
  _id: string;
  walletPubkey: string;
  rewardToken: string;
  amountOption: AmountOption;
  staticAmount: string;
  minAmount: string;
  intervalOption: IntervalOption;
  lastRewardDate: Date | null;
  isEnableUs: boolean;
  percent2Us?: string;
  usAddress?: string;
  rewardVersion: number;
  status: RewardStatus;
  msg?: string;
  isEnable: boolean;
}

export interface IReward2History {
  _id: string;
  date: Date;
  rewardVersion: number;
  sender: string;
  receiver: string;
  rewardToken: string;
  totalRewardAmount: number;
  holdingAmount: number;
  holdingPercent: number;
  rewardAmount: number;
  txId?: string;
  txStatus: TxStatus;
  failedCount?: number;
  failedMsg?: string;
}
